<script setup>
import FormButton from '../../components/Atoms/FormButton.vue'
import IconBase from '../../components/icon/IconBase.vue'
import IconCheckInCircle from '../../components/icon/IconCheckInCircle.vue'

defineOptions({ name: 'PasswordResetEmailNotice' })

defineProps({
  modelValue: { type: Boolean, default: false },
  email: { type: String, default: '' },
  processing: { type: Boolean, default: false }
})

const emit = defineEmits(['back-to-login'])
</script>

<template>
  <Teleport to="body">
    <div v-if="modelValue" class="reset-notice-page">
      <div class="flex flex-col items-center text-center mb-7">
        <img class="w-[120px] h-10" src="@/assets/castr.svg" alt="Castr" />
      </div>
      <div class="reset-notice-card">
        <IconBase
          width="56"
          height="56"
          width-view-box="16"
          height-view-box="16"
          class-icon="mx-auto mb-4 text-success"
        >
          <IconCheckInCircle />
        </IconBase>
        <h2 class="text-xl font-medium mb-3">Password reset email sent</h2>
        <p class="text-surface-8 text-sm mb-2">
          We've sent a password reset link to
          <span class="text-white font-medium">{{ email }}</span>.
          Please check your inbox and follow the instructions to create a new password.
        </p>
        <p class="text-surface-7 text-xs mb-6">
          If you don't see it, check your spam or junk folder, or try again in a few minutes.
        </p>
        <FormButton
          class="mx-auto justify-center"
          :disabled="processing"
          @click="emit('back-to-login')"
        >
          {{ processing ? 'Signing out...' : 'Back to Login' }}
        </FormButton>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.reset-notice-page {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  background-color: var(--surface-1, #0b1020);
}
.reset-notice-card {
  width: 100%;
  max-width: 384px;
  background-color: var(--surface-2, #1a2138);
  border: 1px solid var(--surface-3, #2a3354);
  border-radius: 16px;
  box-shadow: 0 24px 60px -24px rgba(0, 0, 0, 0.9);
  padding: 40px 36px 32px;
  text-align: center;
}
</style>
